import { type TargetType } from '@atlassiansox/cross-flow-base-types';

export const getBenefitsPageRoute = (productKey: TargetType) => `/learn-more/${productKey}`;

export const getDiscoverProductsPageRoute = () => '/';
